import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type TemplateCategoryNotFoundErrorOptions = {
  category: ObjectId;
};

export class TemplateCategoryNotFoundError extends FleekError<TemplateCategoryNotFoundErrorOptions> {
  public name = 'TemplateCategoryNotFoundError';

  toString = () => `Template category not found.`;
}
